<template>
  <div>
    <v-select
      :items="comparadores"
      label="Versão App"
      item-text="text"
      item-value="value"
      v-model="comparadorSelecionado"
    />
    <div v-show="showVersaoAppField">
      <v-text-field
        label="Versão App"
        v-model="versaoAppSelecionada"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroVersaoApp',
  data() {
    return {
      comparadores: [
        {
          text: 'Não comparar',
          value: null
        },
        {
          text: 'Igual a',
          value: '='
        },
        {
          text: 'Maior que',
          value: '>'
        },
        {
          text: 'Menor que',
          value: '<'
        }
      ],

      versaoAppSelecionada: '',
      comparadorSelecionado: null
    }
  },
  computed: {
    tudo() {
      return `${this.versaoAppSelecionada}|${this.comparadorSelecionado}`
    },
    showVersaoAppField() {
      return this.comparadorSelecionado !== null
    }
  },
  watch: {
    tudo() {
      this.$emit('filtrar-versao-app', {
        comparador_versao: this.comparadorSelecionado,
        versao_app: this.versaoAppSelecionada
      })
    }
  }
}
</script>
